import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface SubscriptionPlanTileStyles {
  container: Styles
  trial: Styles
  radioButton: Styles
  plan: Styles
}

const RIGHT_SPACE = 16

export const useStyles = createUseStyles<SubscriptionPlanTileStyles>((theme) => {
  return {
    container: {
      display: 'flex',
      position: 'relative',
      padding: theme.calcUnit(theme.spacing.s3),
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.calcUnit(theme.spacing.s2),
      alignSelf: 'stretch',
    },
    trial: {
      backgroundColor: theme.colors.webButtonBackground,
      paddingTop: theme.calcUnit(theme.spacing.s1),
      paddingRight: theme.calcUnit(theme.spacing.s2),
      paddingBottom: theme.calcUnit(theme.spacing.s1),
      paddingLeft: theme.calcUnit(theme.spacing.s2),
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      position: 'absolute',
      top: theme.calcUnit(-12),
      right: theme.calcUnit(RIGHT_SPACE),
      textTransform: 'uppercase',
    },
    plan: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.calcUnit(theme.spacing.s1),
      alignSelf: 'stretch',
    },
    radioButton: {
      opacity: '0',
    },
  }
})
